import LightTriangle from "./LightTriangle";

export default LightTriangle;
